import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useSound } from '../contexts/SoundContext';
import PageLayout from '../components/PageLayout';

const GAME_MODES = [
  {
    id: 'cpc',
    label: 'CONTROL POINT CLASH',
    description: 'Capture and hold control points to win.',
    path: '/maps/cpc',
    available: true,
    icon: '🏴',
  },
  {
    id: '5v5',
    label: '5V5 DEATHMATCH',
    description: 'Eliminate the enemy team to victory.',
    path: '/maps/5v5',
    available: true,
    icon: '💀',
  },
];

const MapsPage = () => {
  const { t } = useLanguage();
  const { playButtonClick } = useSound();
  const location = useLocation();

  useEffect(() => {
    document.title = `Maps - ${t('app.title')}`;
  }, [t, location]);

  return (
    <PageLayout title="Maps" subtitle="Explore all game modes and their maps">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-2xl mx-auto">
        {GAME_MODES.map((mode) => {
          const cardBase =
            'relative flex flex-col items-center justify-center rounded-2xl border p-8 text-center transition-all duration-200 min-h-[200px]';

          if (mode.available) {
            return (
              <Link
                key={mode.id}
                to={mode.path}
                onClick={playButtonClick}
                className={`${cardBase} bg-white dark:bg-[#1A1A1A] border-indigo-200 dark:border-[#FF8A65] hover:shadow-xl hover:border-indigo-400 dark:hover:border-[#FF5722] hover:-translate-y-1 cursor-pointer`}
              >
                <span className="text-5xl mb-4">{mode.icon}</span>
                <h2 className="text-lg font-bold text-gray-900 dark:text-white tracking-wide">
                  {mode.label}
                </h2>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  {mode.description}
                </p>
              </Link>
            );
          }

          return (
            <div
              key={mode.id}
              className={`${cardBase} bg-gray-50 dark:bg-[#111] border-gray-200 dark:border-[#2A2A2A] opacity-60 cursor-not-allowed`}
            >
              <span className="absolute top-3 right-3 text-xs font-semibold px-2 py-0.5 rounded-full bg-indigo-100 dark:bg-[#2A1A0A] text-indigo-600 dark:text-[#FF9800]">
                Upcoming
              </span>
              <span className="text-5xl mb-4">{mode.icon}</span>
              <h2 className="text-lg font-bold text-gray-400 dark:text-gray-600 tracking-wide">
                {mode.label}
              </h2>
              <p className="mt-2 text-sm text-gray-400 dark:text-gray-600">
                {mode.description}
              </p>
            </div>
          );
        })}
      </div>
    </PageLayout>
  );
};

export default MapsPage;
